import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { IPaginationStoreManagersFilter } from '../../../api';
import { StoreManagerAccountPagingResult } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { ShopService } from '../../../places/shop.service';
import { IStoreForShopingListItem, IStoreManagerAccountListItem } from '../../models';
import { StoreManagerService } from '../../storeManager.service';

class StoreManagerAccountsController implements ng.IController {
    public static $inject = ['$rootScope', '$scope', '$q', 'storeManagerService',
        'shopService', 'popupService', 'notificationService', '$translate'];

    public waiting = false;
    public staff = null as StoreManagerAccountPagingResult;

    public settings = {
        pageSize: 10,
        page: 1,
        places: [] as IStoreForShopingListItem[],
        isStaffAny: {
            active: null,
            archived: false
        },
        isAllStaffSelected: false,
        filter: {
            place: null as IStoreForShopingListItem,
            keyword: null as string,
            isActive: true
        },
        sort: this.storeManagerService.getColumnSort(),
        getFilter: (): IPaginationStoreManagersFilter => {
            const i = this.settings;
            const placeID = i.filter.place ? i.filter.place.ID : '';
            const keyword = i.filter.keyword ? i.filter.keyword.trim() : '';

            return {
                limit: i.pageSize,
                offset: (i.page - 1) * i.pageSize,
                sortColumn: i.sort.column,
                sortOrder: i.sort.order,
                placeID,
                keyword,
                isActive: i.filter.isActive
            };
        },
        setPlaces: (places) => {
            const i = this.settings;
            i.places = _.isArray(places) ? angular.copy(places) : [];
            i.places.unshift({
                ID: null,
                Name: this.$translate.instant('all')
            } as IStoreForShopingListItem);
        },
        setCheckboxes: () => {
            const i = this.settings;
            if (this.staff) {
                _.forEach(this.staff.Items as IStoreManagerAccountListItem[], (staff) => {
                    staff.selected = i.isAllStaffSelected;
                });
            }
        },
        changeSelected: (staff: IStoreManagerAccountListItem) => {
            this.settings.isAllStaffSelected = _.all(this.staff.Items as IStoreManagerAccountListItem[], (staff) => {
                return staff.selected;
            });
        },
        isStaffSelected: () => {
            return this.staff ? _.any(this.staff.Items as IStoreManagerAccountListItem[], (staff) => {
                return staff.selected;
            }) : false;
        },
        showPanel: () => {
            const i = this.settings;
            return (i.filter.isActive && i.isStaffAny.active) || (!i.filter.isActive && i.isStaffAny.archived);
        },
        isPlacesAny: () => {
            return _.size(this.placesModel.active) > 0;
        }
    };

    private placesModel = {
        all: [] as IStoreForShopingListItem[],
        active: [] as IStoreForShopingListItem[],
        archived: [] as IStoreForShopingListItem[],
        set: (places: IStoreForShopingListItem[]) => {
            const i = this.placesModel;
            i.all = places;
            _.forEach(i.all, (place) => {
                place.info = place.Name + ', ' + place.Town + ', ' + place.Address;
            });
            i.active = _.where(places, { IsActive: true });
            i.archived = _.where(places, { IsActive: false });
        }
    };

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private storeManagerService: StoreManagerService,
        private shopService: ShopService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService
    ) {

    }

    public async $onInit() {
        await this.init();
    }

    public async init() {
        try {
            this.waiting = true;
            this.notificationService.showWaitingMessage();
            const places = await this.shopService.getStoresForManager() as IStoreForShopingListItem[];
            this.placesModel.set(places);
            this.getManagers();
            this.settings.setPlaces(this.placesModel.active);
            this.$scope.$watchGroup(['vm.settings.sort.column', 'vm.settings.sort.order', 'vm.settings.filter.keyword',
                'vm.settings.filter.place', 'vm.settings.page', 'vm.settings.filter.isActive'], (n, o) => {
                this.settings.isAllStaffSelected = false;
                this.settings.setCheckboxes();
                if (n && n !== o) {
                    this.getManagers();
                }
            });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public async archiveStaff(staff: IStoreManagerAccountListItem) {
        let selectedStaff = [];
        if (staff) {
            selectedStaff = [staff];
        } else {
            selectedStaff = _.where(this.staff.Items, { selected: true });
        }
        const size = _.size(selectedStaff);
        if (size === 0) {
            return;
        }
        this.waiting = true;
        try {
            const popupContent = `<p>${this.$translate.instant(size > 1 ? 'archive_selected_accounts_confirm' : 'acrhive_a_selected_account_confirm')}</p>`;
            const popupTitle = this.$translate.instant(size > 1 ? 'archive_selected_accounts' : 'acrhive_a_selected_account');

            let li = '';
            _.forEach(selectedStaff, (staff) => {
                li += '<li>' + staff.FirstName + ' ' + staff.LastName + '</li>';
            });
            const ul = '<ul>' + li + '</ul>';
            await this.popupService.confirm({
                title: popupTitle,
                content: popupContent + ul,
                okTxt: this.$translate.instant('no'),
                cancelTxt: this.$translate.instant('yes'),
                cancelClass: 'btn-success',
                invertAction: true,
            });
            this.notificationService.showWaitingMessage();
            const ids = _.pluck(selectedStaff, 'ID');
            await this.storeManagerService.archiveAccount(ids);
            this.getManagers();
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
        this.waiting = false;
    }

    public async restoreStaff(staff: IStoreManagerAccountListItem) {
        let selectedStaff = [];
        if (staff) {
            selectedStaff = [staff];
        } else {
            selectedStaff = _.where(this.staff.Items, { selected: true });
        }
        const ids = _.pluck(selectedStaff, 'ID');
        if (_.size(ids) === 0) {
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.storeManagerService.restoreAccount(ids);
            this.settings.filter.isActive = true;
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }

    public async setStaff(staff: IStoreManagerAccountListItem) {
        try {
            await this.storeManagerService.openAccountManager(staff, this.placesModel.all);
            this.getManagers();

        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClick(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    private async getManagers() {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const response = await this.$q.all([this.storeManagerService.getAccounts(this.settings.getFilter()), this.storeManagerService.isAccountAny(true), this.storeManagerService.isAccountAny(false)]);

            this.notificationService.clearAll();
            this.staff = response[0];
            this.settings.isStaffAny.active = response[1];
            this.settings.isStaffAny.archived = response[2];
            _.forEach(this.staff.Items as IStoreManagerAccountListItem[], (staff) => {
                staff.places = [];
                _.forEach(staff.PlacesID, (id) => {
                    const place = _.findWhere(this.placesModel.all, { ID: id });
                    if (place) {
                        staff.places.push({
                            id: place.ID,
                            info: place.info,
                            isActive: place.IsActive
                        });
                    }
                });
            });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

}

angular
    .module('naut')
    .component('storeManagerAccounts', {
        template: require('./storeManagerAccounts.html'),
        controller: StoreManagerAccountsController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/store-managers/components/storeManagerAccounts/storeManagerAccounts.component.ts